import { render, staticRenderFns } from "./ClaimRecordGrid.vue?vue&type=template&id=234a10b1"
import script from "./ClaimRecordGrid.vue?vue&type=script&lang=js"
export * from "./ClaimRecordGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports